import React from 'react';
import {Grid} from '@mui/material';
import {FeatureIconMap, hasFeatureIcon, LocationFeatureTypography} from "./FeatureIconMap";

interface LocationFeatureListItemProps {
  feature: string;
}

const LocationFeatureListItem = (props: LocationFeatureListItemProps) => {
  const {feature} = props;

  const FeatureIcon = hasFeatureIcon(feature) ? FeatureIconMap[feature] : undefined;

  return <Grid item>
    <Grid container spacing={1}>
      <Grid item>
        {/*
          for some reason making a Grid item makes a containing div that doesn't have display: flex; on it.
          this causes any flex properties to not work in child components. In order to get the child component to
          flex properly you need to create another container within it. fyi, i also tried creating <Grid item container>
          but that creates the structure <div class='Mui-container'><div class='Mui-item>{children}</div></div> which, as
          you can see, runs into the same problem. having extra containers is kinda annoying, but not the worst.
        */}
        <Grid container>
          {FeatureIcon && <FeatureIcon fontSize={'small'} htmlColor={'#7C8597'} />}
        </Grid>
      </Grid>
      <Grid item alignSelf={'center'}>
        <LocationFeatureTypography>
          {feature}
        </LocationFeatureTypography>
      </Grid>
    </Grid>
  </Grid>
}

export default LocationFeatureListItem;
